import KreditPages from "../components/KreditPages";
import fetch from "../utils/fetch";

const kreditKamera = ({ query, promos, asPath, item }) => {
  return (
    <KreditPages
      query={query}
      promos={promos}
      asPath={asPath}
      item={item}
    ></KreditPages>
  );
};

kreditKamera.getInitialProps = async ({ res, query, asPath }) => {
  const listOfflineShop = await fetch("GET", `/static/offlineShop`, {}, true);

  if (listOfflineShop.status === 200) {
    const item = await listOfflineShop.data.data.find(
      ({ key }) => key === `kredit-kamera`
    );

    const { status, data } = await fetch(
      "GET",
      `/kentico/promo-list`,
      {
        commodity: item.data.promo_code,
        elements: "promo"
      },
      true
    );

    if (status === 200) {
      return {
        query,
        promos: data,
        asPath,
        item: item.data
      };
    } else {
      if (res) {
        res.writeHead(302, {
          Location: `/halaman-tidak-ditemukan?q=kredit-kamera`
        });
        res.end();
      }
      return;
    }
  } else {
    if (res) {
      res.writeHead(302, {
        Location: `/halaman-tidak-ditemukan?q=kredit-kamera`
      });
      res.end();
    }
    return;
  }
};

export default kreditKamera;
